@if(this.questionnaire){

    <form class="mission_questionnaire" [formGroup]="this.questionnaireForm" (ngSubmit)="this.saveQuestionnaire()">
        
        <div class="mission_questionnaire_groups">
            @for(i of this.numberOfMetaRanks; track $index){

                @for(group of this.questionnaire.groups; track $index){

                    @if(group.availableOnMetaRank != null && group.availableOnMetaRank.includes(i)){

                        <div class="mission_questionnaire_group">
                            <div class="mission_questionnaire_group_name">{{group.name}}</div>
                            <div class="mission_questionnaire_fields">

                                @for(field of group.datafields; track $index){

                                    @if(field.metaRank == i && this.fieldsVisibility.get(field.code)){

                                        <div class="mission_questionnaire_field">                                        
                                            <marv-field [label]="field.shortName" icon="help-circle-outline">                                        
                                                <div class="mission_questionnaire_field_input">
                                                    @switch (field.type) {

                                                        @case ('DOUBLE') {
                                                            <marv-input 
                                                                type="number" 
                                                                [formName]="field.code" 
                                                                [withSpeechToText]="true" 
                                                                [disabled]="this.disabledForm"
                                                                />
                                                        }

                                                        @case ('INTEGER') {
                                                            <marv-input 
                                                                type="number"                                                   
                                                                [formName]="field.code" 
                                                                [withSpeechToText]="true" 
                                                                [disabled]="this.disabledForm"
                                                                />
                                                        }

                                                        @case ('STRING') {

                                                            @if(this.shouldUseTextArea(field)){
                                                                <marv-textarea                                                                                                            
                                                                    [formName]="field.code" 
                                                                    [withSpeechToText]="true"
                                                                    [disabled]="this.disabledForm"
                                                                    />
                                                            }
                                                            @else{
                                                                <marv-input 
                                                                    type="text"                                                            
                                                                    [formName]="field.code" 
                                                                    [withSpeechToText]="true" 
                                                                    [disabled]="this.disabledForm"
                                                                    />
                                                            }

                                                        }

                                                        @case ('DATE') {
                                                            <marv-input-date                                                        
                                                                [formName]="field.code"                                                                                              
                                                                [withSpeechToText]="true" 
                                                                [disabled]="this.disabledForm" 
                                                                />  
                                                        }

                                                        @case ('BOOLEAN') {
                                                            <marv-select 
                                                                [formName]="field.code"
                                                                [items]="this.booleanOptions" 
                                                                [disabled]="this.disabledForm"
                                                                />    
                                                        }

                                                        @case ('ENUM') {                                                    
                                                            <marv-select 
                                                                [formName]="field.code"
                                                                [items]="this.mapOptions.get(field.code) || []" 
                                                                [disabled]="this.disabledForm"
                                                                />                                                        
                                                        }

                                                        @case ('MCQ') {
                                                            <marv-select 
                                                                [formName]="field.code"
                                                                [items]="this.mapOptions.get(field.code) || []" 
                                                                [multiple]="true"
                                                                [disabled]="this.disabledForm"
                                                                />    
                                                        }

                                                        @case ('PHOTO') {
                                                            <marv-input-file               
                                                                [formName]="field.code"
                                                                [(file)]="fieldsPhotos[field.code]"                                                                 
                                                                [acceptFiles]="this.photosFileExt" 
                                                                [showBtnClearInput]="true"
                                                                [disabled]="this.disabledForm"
                                                                />
                                                        }

                                                    }
                                                </div>
                                            </marv-field>
                                        </div>
                                    }

                                }

                            </div>
                        </div>
                    }

                }

            }
        </div>
        
        <ion-grid>
            <ion-row class="ion-justify-content-around">
                <ion-col size="auto">
                    <marv-button type="submit" label="{{ 'VALIDATE' | translate }}" icon="checkmark-outline" color="primary" [isFetching]="this.isFetchingSave"/>
                </ion-col>
                <ion-col size="auto">
                    <marv-button type="button" label="{{ 'CANCEL' | translate }}" icon="close-outline" color="secondary" (click)="this.cancelQuestionnaire()" />
                </ion-col>
            </ion-row>
        </ion-grid>
        
    </form>

}